module.exports = __webpack_public_path__ + "img/partner-banner.c4bbf54f.webp";